import { TableCell } from "@mui/material";
import React from "react";
import { TableTextCellProps } from "./interfaces";

export const TextCell: React.FC<TableTextCellProps> = ({ value, align }) => {
  return <TableCell align={align ?? "left"}>{value}</TableCell>;
};
